"use client";

import dynamic from "next/dynamic";

import type { PricingCalculatorProps } from "./PricingCalculator";

const PricingCalculator = dynamic(() => import("./PricingCalculator").then(mod => mod.PricingCalculator), {
  ssr: false,
});

export function PricingCalculatorWrapper(props: PricingCalculatorProps) {
  return <PricingCalculator {...props} />;
}
